import { useEffect, useState } from 'react';
import FhDateRangeFilter from 'Views/Components/_HumanWritten/DateSelectorFilter/FhDateSelectorFilter';

export type StaffFiltersDatePickerOptions =
	| 'Trip Date'
	| 'Created Date'
	| 'Expiry Date'
	| 'Parking Date'
	| 'Charter Date';

export interface StaffFiltersDatePickerProps {
	options: StaffFiltersDatePickerOptions[];
	startDate?: Date;
	endDate?: Date;
	filterByCreatedDate: boolean;
	allowFutureDates?: boolean;
	onDateChange: (startDate: Date | undefined, endDate: Date | undefined) => void;
	onFilterTypeChange: (filterByCreatedDate: boolean) => void;
}

export function StaffFiltersDatePicker({
	options,
	startDate,
	endDate,
	filterByCreatedDate,
	allowFutureDates,
	onDateChange,
	onFilterTypeChange,
}: StaffFiltersDatePickerProps) {
	const otherOption = options.find(o => o !== 'Created Date') ?? options[0];

	// Initialize based on filter state
	const [activeTab, setActiveTab] = useState<StaffFiltersDatePickerOptions>(
		filterByCreatedDate ? 'Created Date' : otherOption,
	);

	// Sync activeTab when filterByCreatedDate changes
	useEffect(() => {
		const correctTab = filterByCreatedDate ? 'Created Date' : otherOption;
		if (activeTab !== correctTab) {
			setActiveTab(correctTab);
		}
	}, [filterByCreatedDate]);

	const handleFilterTypeChange = (newTab: string) => {
		setActiveTab(newTab as StaffFiltersDatePickerOptions);
		const newFilterByCreatedDate = newTab === 'Created Date';
		onFilterTypeChange(newFilterByCreatedDate);
	};

	return (
		<FhDateRangeFilter
			startDate={startDate}
			endDate={endDate}
			onChangeDate={({ startDate: newStartDate, endDate: newEndDate }) => {
				onDateChange(newStartDate, newEndDate);
			}}
			onClear={() => {
				onDateChange(undefined, undefined);
			}}
			maxDate={activeTab === 'Created Date' && !allowFutureDates ? 'today' : undefined}
			options={options}
			active={activeTab}
			onChangeFilterType={handleFilterTypeChange}
		/>
	);
}
